import { Content } from "@/ui/Content";
import * as additionalComponents from "@/components/DiversityPage";
import { router } from "@/router";
import { stripTags } from "@/functions/stripTags";
import { getGlobal } from "@/functions/getGlobal";
import { insights_helper } from "@/helpers/insights_helper";
import sourceflowEnums from "@/sourceflow.enums";

export default function Page({ content }) {
  return (
    <>
      <Content items={content} additionalComponents={additionalComponents} />
    </>
  );
}

export async function getStaticProps({}) {
  const global = getGlobal();
  const insights = insights_helper.fetch({ limit: 3, filter: (i) => ("tags" in i ? i?.tags?.includes("DEI") : false) });

  const routerProp = router["about.diversity.programme-one"];
  const titleKey = "page.programme-one.banner.title";

  return {
    props: {
      meta: {
        en: {
          title: stripTags(global[`${titleKey}.en`]),
          canonical: `${sourceflowEnums.config.baseUrl}${routerProp["en"]}`,
        },
      },
      router: routerProp,
      content: [
        { component: "DiversityPageBannerSection", props: { pathPrefix: "page.programme-one.banner" } },
        { component: "DiversityPageContentSection", props: { pathPrefix: "page.programme-one.content" } },
        { component: "DiversityPageOfferingsSection", props: { pathPrefix: "page.programme-one.offerings" } },
        { component: "CommitteeSection", props: { pathPrefix: "page.programme-one.committee" } },
        { component: "DiversityPageProgrammeOneSection", props: { pathPrefix: "page.programme-one.content-2" } },
        {
          component: "InsightsSection",
          props: { items: insights, title: { path: "page.programme-one.insights.title.en" }, sidebar: false },
        },
        // { component: "AwardsSection", props: { className: "py-4 py-md-5" } },
      ],
    },
  };
}
